export const enrollSteps = [
  {
    name: 'You',
  },
  {
    name: 'Contact',
  },
  {
    name: 'Eligibility',
  },
  {
    name: 'Enroll',
  },
  {
    name: 'Complete',
  },
]

export const renewalSteps = [
  {
    name: 'Eligibility',
  },
  {
    name: 'Contact',
  },
  {
    name: 'History',
  },
  {
    name: 'Verify',
  },
  {
    name: 'Pay',
  },
  {
    name: 'Complete',
  },
]
